import React, { useRef, useEffect, useState, useCallback } from 'react';
import CloseButton from 'react-bootstrap/CloseButton'
import './OutsideDomain.css'


export default function OutsideDomain(props){


    function onCloseCallback(x) {
        console.log('in on close')
        props.closeSideBar()
    }

    return (
        <div className='outsidedomain-contents' >
            <CloseButton className='close-button' onClick={onCloseCallback}></CloseButton>
            <p className='notice'>This location is outside Zeppelin Floods' Los Angeles domain.</p>
        </div>
    );

}